import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpace from 'eco-design/base/eco-space';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.ModuleC');
    const { locale } = getLocal();

    const TOP_LIST = [
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1745459457496/MC1.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
            list: [
                // { text: t('item1_v1'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909032/Well-pump.svg' },
                // { text: t('item1_v2'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745749194951/air-condition.svg' },
                // { text: t('item1_v3'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745749257363/Electric%20Oven.svg' },
                // { text: t('item1_v4'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909269/Heater.svg' },
                // { text: t('item1_v5'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909624/Microwave.svg' },
                // { text: t('item1_v6'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909444/Refrigerator.svg' },

                { text: t('item1_v1'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909444/Refrigerator.svg' },
                { text: t('item1_v2'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909032/Well-pump.svg' },
                { text: t('item1_v3'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909624/Microwave.svg' },
            ],
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1745459457276/MC2.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
            list: [
                // { text: t('item2_v1'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909032/Well-pump.svg' },
                // { text: t('item2_v2'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745749194951/air-condition.svg' },
                // { text: t('item2_v3'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745749257363/Electric%20Oven.svg' },
                // { text: t('item2_v4'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909269/Heater.svg' },
                // { text: t('item2_v5'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909624/Microwave.svg' },
                // { text: t('item2_v6'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909444/Refrigerator.svg' },

                { text: t('item2_v1'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745748909269/Heater.svg' },
                { text: t('item2_v2'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745749257363/Electric%20Oven.svg' },
                { text: t('item2_v3'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745749194951/air-condition.svg' },
            ],
            bz: t('bz'),
        },
    ];

    return (
        <div className={styles.comp} id="ModuleC">
            <EcoSpaceSmall />
            <div className="container">
                <EcoTitle title={t('title')} />
                <EcoSpaceSmall />
                <div>
                    <div className="top">
                        {TOP_LIST.map((i, idx) => (
                            <div className="top-item" key={idx}>
                                <EcoImg pc={i.url} />
                                <div className="top-item-info">
                                    <div className="ModuleC-title">{i.title}</div>
                                    <div className="ModuleC-desc">{i.desc}</div>
                                    <div className="ModuleC-divider"></div>
                                    <div className="ModuleC-grid">
                                        {i.list.map((j, idx2) => (
                                            <div className="ModuleC-grid-item" key={`${idx}-${idx2}`}>
                                                {j.icon && <img src={j.icon} />}
                                                <span>{j.text}</span>
                                            </div>
                                        ))}
                                    </div>
                                    {i.bz && <div className="bz">{i.bz}</div>}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="bottom">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745459457069/MC3.jpg" />
                        <div className="bottom-item">
                            <div className="ModuleC-title">{t('item3_title')}</div>
                            <div className="ModuleC-desc2">{t('item3_desc')}</div>
                            <EcoLink
                                className="ModuleC-btn"
                                href={
                                    locale === 'us'
                                        ? 'https://us.ecoflow.com/products/smart-generator-4000-dual-fuel?variant=41434656637001'
                                        : 'https://ca.ecoflow.com/products/smart-generator-4000-dual-fuel?variant=41434656637001'
                                }
                                target="_blank"
                            >
                                {t('item3_btn')}
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                    <path
                                        d="M7.5 5.63867L12.5 10.6387L7.5 15.6387"
                                        stroke="#3F68E0"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </EcoLink>
                        </div>
                    </div>
                </div>
            </div>
            <EcoSpace />
        </div>
    );
}
